import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CarHome = ({ car }) => {
     const { _id, quantity, name, img, description, price, supplierName } = car;
     const navigate = useNavigate()

     const navigateToCarDetails = id => {
          navigate(`/Inventory/${id}`);

     }
     return (
          <div className='cars-item'>
               <img src={img} alt="" />

               <div className="cars-item-info">
                    <h5>Name : {name}</h5>
                    <p><small>Description : {description}</small></p>
                    <h6>Price : $ {price}</h6>
                    <p><small>Supplier Name : {supplierName}</small></p>
                    <p>{quantity}</p>

                    <button onClick={() => navigateToCarDetails(_id)} className='btn btn-primary'>Add Cars</button>

               </div>




          </div>
     );
};

export default CarHome;